const SendMessage = () => {
  return (
    <svg
      width="1em"
      height="1em"
      fontSize="inherit"
      viewBox="0 0 19 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M16.9955 8.92673C17.88 9.36896 17.88 10.6311 16.9955 11.0734L2.69331 18.2245C1.76447 18.6889 0.724251 17.8343 0.999608 16.833L2.65992 10.7955C2.8031 10.2748 2.8031 9.72518 2.65992 9.20453L0.999618 3.16712C0.724259 2.16582 1.76448 1.3112 2.69332 1.77562L16.9955 8.92673Z"
        stroke="#0A292E"
        strokeWidth="1.5"
      />
      <path
        d="M6.11114 10.0001L3.28271 10.0001"
        stroke="#0A292E"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default SendMessage;
